// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// @ts-nocheck
/* eslint-disable */
import React from 'react';

export const ErrorBoundary = ({ error }: { error: any }) => (
  <div>{error?.message}</div>
);
